import { createContext, useContext, useState } from "react";
import BookingModal from "@/components/BookingModal";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <BookingContext.Provider value={{ openBooking: () => setOpen(true) }}>
      {children}
      <BookingModal open={open} onOpenChange={setOpen} />
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext) || { openBooking: () => {} };
